module.exports = __webpack_public_path__ + "static/img/1.aac4c85.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/1.png
// module id = aEiT
// module chunks = 0